// Amenity id → human label lookup (kebab-case ids are what's stored in the DB)
export const AMENITY_LABEL_BY_ID = {
  wifi: 'WiFi',
  tv: 'TV',
  heating: 'Heating',
  ac: 'Air conditioning',
  washer: 'Washer',
  dryer: 'Dryer',
  iron: 'Iron',
  'hair-dryer': 'Hair dryer',
  hangers: 'Hangers',
  essentials: 'Towels & linens',
  kitchen: 'Kitchen',
  fridge: 'Refrigerator',
  microwave: 'Microwave',
  oven: 'Oven',
  stove: 'Stove',
  dishwasher: 'Dishwasher',
  'coffee-maker': 'Coffee maker',
  kettle: 'Kettle',
  dishes: 'Dishes & silverware',
  'wine-glasses': 'Wine glasses',
  toaster: 'Toaster',
  shower: 'Shower',
  bathtub: 'Bathtub',
  'hot-water': 'Hot water',
  shampoo: 'Shampoo',
  'body-soap': 'Body soap',
  'toilet-paper': 'Toilet paper',
  pool: 'Pool',
  'hot-tub': 'Hot tub',
  patio: 'Patio',
  balcony: 'Balcony',
  backyard: 'Backyard',
  garden: 'Garden',
  bbq: 'BBQ grill',
  firepit: 'Fire pit',
  'beach-access': 'Beach access',
  'lake-access': 'Lake access',
  'mountain-view': 'Mountain view',
  'city-view': 'City view',
  'forest-view': 'Forest view',
  parking: 'Free parking on premises',
  'street-parking': 'Street parking',
  'paid-parking': 'Paid parking',
  'ev-charger': 'EV charger',
  bike: 'Bikes available',
  gym: 'Gym',
  sauna: 'Sauna',
  fireplace: 'Indoor fireplace',
  'sound-system': 'Sound system',
  'game-console': 'Game console',
  books: 'Books & reading',
  'smart-tv': 'Smart TV',
  crib: 'Crib',
  'high-chair': 'High chair',
  'pets-allowed': 'Pets allowed',
  'step-free-access': 'Step-free access',
  'wide-doorway': 'Wide doorway',
  workspace: 'Dedicated workspace',
  desk: 'Desk',
  monitor: 'External monitor',
  printer: 'Printer',
  'fast-wifi': 'Fast WiFi (50+ Mbps)',
  'smoke-alarm': 'Smoke alarm',
  'co-alarm': 'CO alarm',
  'fire-extinguisher': 'Fire extinguisher',
  'first-aid': 'First aid kit',
  'security-cameras': 'Exterior security cameras',
  lockbox: 'Lockbox',
  'self-check-in': 'Self check-in',
  'smart-lock': 'Smart lock',
  'building-staff': 'Building staff',
  'long-term': 'Long-term stays allowed',
  'cleaning-products': 'Cleaning products',
  'no-smoking': 'No smoking',
};
